$(document).ready(function () {
    $('.video__play').click(function () {

        $(this).parent().addClass('removed');
        const $video = $(this).parents('.video'),
                video = $video.find('.video__model');
        $video.addClass('active');
        // video.get(0).currentTime = 0;
        video.attr('controls', 'controls');

        setTimeout(()=> {
            video.get(0).play();
        }, 10);

        if ($video.hasClass('video_scallable')) {
            $video.animate({
                height: video.height()
            }, 250);
        }

    });

    const videoSection = $('.section_video');
    if ($(window).width() > 768 && videoSection.length) {
        videoSection.append(
            `<div class="video video_major">
                    <video loop="loop" preload="metadata" muted="muted" autoplay="autoplay">
                        <source src="https://i.changanauto.ru/uploads/video/uni-k.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                    </video>
                </div>`
        );
    }

    $('.video__model').each(function(){

      const video = $(this).get(0);
      video.pause();

    });
});